<template>
<div class="mt_140">

    <ccMenu ref="cc_menu" v-bind:posicao=2></ccMenu>
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container">
    <div class="row">
    <div class="col-md-12 ps-4 p-2" style="background: #171A26 0% 0% no-repeat padding-box; border-radius: 17px 17px 0px 0px;">

      <div class="row">

          <!-- COLUNA 1 ---------------------------------------------------------------------------------------------------------->
          <div class="col-md-4" id="real_time">

            <!-- BOX TORNEIO ---------->
            <div class="row">
              <div class="col-md-12 pt-3" style="background: #FFFFFF08 0% 0% no-repeat padding-box; border-radius: 12px 12px 0px 0px;">


                  <!-- turbo -->
                  <div v-if="torneio.tipo_id == 4" class="text_14 text_branco text_bold">{{jogos[0].time1_nome}} x {{jogos[0].time2_nome}}</div>
                  <!-- torneios demais -->
                  <div v-else class="text_14 text_branco text_bold">{{torneio.nome}}</div>

                  <div v-if="torneio.tipo_id == 4" class="text_14 text_bold text_cinza">
                    {{ torneio.mercado_escolhido >= 9 && torneio.mercado_escolhido <= 16 ? 'CANTO' : 'GOL' }}
                    {{nomeMercadoEscolhido(torneio.mercado_escolhido)}}
                  </div>

                  <div class="mb-2">
                    <div>
                      <span class="text_13 text_cinza">Entrada:</span> <span class="text_14 text_cinza">R${{formatarMoeda(torneio.taxa_entrada)}}</span>
                      <span class="text_13 text_cinza">Premiação Total:</span> <span class="text_14 text_cinza">R${{torneio.prize}}</span>
                    </div>
                    <div><span class="text_13 text_cinza">Posições Pagas:</span> <span class="text_14 text_cinza">1º até {{ultimo_que_ganha}}º</span></div>
                    <div class="pt-2 mb-1" style="border-bottom: 1px solid #70707080;"></div>
                    <div> <span class="text_13 text_branco">Início:</span>  <span class="text_13 text_cinza">{{timestamp_dataBR(torneio.dt_inicio_timestamp,4)}}</span> <span class="text_13 text_verde">{{torneio.status_nome}}</span> </div>
                    <div> <span class="text_13 text_branco">Previsão de Término:</span>  <span class="text_13 text_cinza">{{timestamp_dataBR(torneio.dt_termino_timestamp, 4)}}</span></div>
                    <div class="pt-2 mb-1" style="border-bottom: 1px solid #70707080;"></div>
                    <div class="text_14 text_branco text_bold">RANKING EM TEMPO REAL:</div>
                    <div> <span class="text_13 text_branco">Sua Colocação:</span> <span class="text_verde">{{sua_colocacao}}</span> </div>
                    <div> <span class="text_13 text_branco">Ganhos Totais:</span> <span class="text_14 text_bold text_verde">R$ {{formatarMoeda(meus_total_ganhos)}}</span> </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-7">
                      <input type="text" v-model="filter_username" class="form-control form-control-sm" placeholder="Pesquisar Jogador" v-on:keyup="filter_nome_usuario()">
                    </div>
                    <div class="col-md-5">
                      <div class="text_13 pt-1" style="cursor:pointer; border-radius:5px;"
                      @click="show_only()" v-bind:class="[ (only==1)?'only_true' : (only==0)?'only_false':'']">
                      Mostrar apenas eu
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">

                      <div class="caixa_aposta">

                        <table class="table tabela" v-if="qtd_minhas_apostas > 0 && (torneio.tipo_id != 1 && torneio.tipo_id != 4)">
                          <thead>
                            <tr>
                              <th>Posição</th>
                              <th>Usuário</th>
                              <th class="text-center">Pontuação</th>
                              <th style="text-align: center;">Ganhos</th>
                              <th v-show="torneio.status == 1" style="text-align: center;"> </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="aposta of meus_palpites" @click="selecione_aposta(aposta.aposta_id)" v-if="aposta.user_id==user.id"
                            v-bind:class="{'disabled':aposta.cadeado==0, 'escolheu_aposta':aposta.escolha==1 }">
                              <td>{{aposta.rank}}º</td>
                              <td>
                                <span style="font-size:10px;">{{aposta.username}} {{aposta.entrada==1?"":"("+aposta.entrada+")"}}</span>
                              </td>
                              <td class="text-center">{{aposta.ponto}}</td>
                              <td class="text_bold text_verde text-center"> R$ {{formatarMoeda(aposta.prize.toFixed(2))}}</td>
                              <td class="text-center" v-show="torneio.status == 1 && torneio.tipo_id != 4">
                                <router-link v-if="aposta.cadeado==1" :to="{ name:'editar_aposta_sem_componente', params: {aposta_id: aposta.aposta_id} }" class="btn btn-warning btn-sm text_10"
                                style="background-color: #f7af32; border: 0; padding:1px;">
                                  <i class="far fa-calendar-check"></i> EDITAR
                                </router-link>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <table class="table tabela">
                          <thead>
                            <tr>
                              <th>Posição</th>
                              <th>Usuário</th>
                              <th class="text-center">Pontuação</th>
                              <th style="text-align: center;">Ganhos</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="aposta of apostas_page" @click="selecione_aposta(aposta.aposta_id)"
                            v-bind:class="{'disabled':aposta.cadeado==0, 'escolheu_aposta':aposta.escolha==1 }">
                              <td>{{aposta.rank}}º</td>
                              <td>
                                <span style="font-size:10px;">{{aposta.username}} {{aposta.entrada==1?"":"("+aposta.entrada+")"}}</span>
                              </td>
                              <td class="text-center">{{aposta.ponto}}</td>
                              <td class="text_bold text_verde text-center"> R$ {{formatarMoeda(aposta.prize.toFixed(2))}}</td>
                              <td class="text-center" v-show="torneio.status == 1 && torneio.tipo_id != 4">
                                <router-link v-if="aposta.cadeado==1" :to="{ name:'editar_aposta_sem_componente', params: {aposta_id: aposta.aposta_id} }" class="btn btn-warning btn-sm text_10"
                                style="background-color: #f7af32; border: 0; padding:1px;">
                                  <i class="far fa-calendar-check"></i> EDITAR
                                </router-link>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <nav aria-label="...">
                        <ul class="pagination pagination-sm">
                          <li class="page-item"><a class="page-link" href="#" v-on:click.prevent="page_primeiro()"> << </a></li>
                          <li class="page-item"><a class="page-link" href="#" v-on:click.prevent="page_menos()"> < </a></li>
                          <li class="page-item"><a class="page-link" href="#" v-on:click.prevent="page_add()"> > </a></li>
                          <li class="page-item"><a class="page-link" href="#" v-on:click.prevent="page_ultima()"> >> </a></li>
                        </ul>
                      </nav>
                    </div>
                    <div class="col-md-6 text-right paginas">
                      {{this.page}}/{{this.page_ultimo}}
                    </div>
                  </div>
                  <!-- FIM BOX APOSTAS -------------->

                  <div class="pb-2" v-if ="torneio.status > 2">
                    <router-link
                      :to="{ name: 'torneio_auditoria', params: { torneio_id: torneio.id } }"
                      type="button" class="btn btn-outline-info w-100 btn-sm text_12"
                    >
                      TRANSPARÊNCIA: BAIXE AUDITORIA DO TORNEIO
                    </router-link>
                  </div>
              </div>
            </div>
            <!-- FIM BOX TORNEIO ---------->

          </div>
          <!-- FIM COLUNA 1 ---------------------------------------------------------------------------------------------------------->

          <!-- COLUNA 2 -->
          <!-- <div class="col-md-8" v-show="dados_disponiveis"> -->
          <div class="col-md-8">

              <div class="row" v-if="torneio.tipo_id != 4">
                <div class="col-md-12 mb-3 text-end">
                  <router-link :to="{name:'torneio_detalhes', params:{torneio_id:torneio.id, page_back:0} }" class="text_branco text-center text_10 mt-1 w-100">
                    <b>VER DETALHES</b>
                  </router-link>
                </div>
              </div>

              <div class="row" v-if="aposta_id > 0">
                <div class="col-md-10 mb-3">
                  <span class="text_bold text_verde">{{aposta_escolhida_nickname}}</span> &nbsp;&nbsp;&nbsp;
                  <span class="text_bold text_laranja">Id da aposta:</span> <span class="text_laranja">{{aposta_id}}</span> &nbsp;&nbsp;&nbsp;
                  <span class="text_bold text_verde">Valor ganho:</span> <span class="text_verde">R$  {{formatarMoeda(aposta_escolhida_valor_ganho)}}</span>
                </div>
              </div>

              <div v-if="mercado_opcao.length == 0" class="text_18 text_branco text-center pt-5">
                Não possui apostas
              </div>

              <div class="row p-2">
                  <div v-show="dados_disponiveis" class="col-md-6 p-3 bg_cinzas" id="box_mercado_opcoes" style="background: #E4E4E408 0% 0% no-repeat padding-box; border: 1px solid #6666660D; border-radius: 5px 5px 0px 0px;">
                    <div class="row">
                      <div class="col-md-6" v-for="opcao of mercado_opcao" style="padding:2px; cursor:pointer;" @click="get_resultado(opcao.fixture_id)">

                        <div class="card opcao" v-bind:class="[
                          {acesso:opcao.status=='LIVE'},
                          {apagado:opcao.status!='LIVE'},
                          {verde:opcao.resultado=='S'},
                          {vermelho:opcao.resultado=='N'},
                          {azulado:opcao.resultado==null && opcao.status!='LIVE'},
                          {cinza:opcao.resultado==null && opcao.status=='LIVE'},
                          {amarelo:opcao.status=='INT'},
                        ]">

                          <div class="row" style="padding-top:5px;" v-bind:class="[
                          {verde:opcao.resultado=='S'},
                          {vermelho:opcao.resultado=='N'}
                          ]">
                            <div class="col-md-12 text_10 text-center text_bold" v-bind:class="[
                              {aovivo_vermelho:opcao.status=='LIVE'}
                            ]">
                              {{opcao.status==null?"-":opcao.status}}
                            </div>
                          </div>

                          <div class="row" style="padding:0 20px 0 20px;">
                            <div class="col-4 text-center" style="padding:0;">
                              <div><img :src='opcao.localteam_logo' class="imagem"></div>
                              <div class="mt_4 text_13 text_cinza">
                                {{opcao.localteam_nome.substr(0,3).toUpperCase()}}
                              </div>
                            </div>

                            <div class="col-4 placar text-center text_bold" style="padding:0;">
                              <div style="font-size: 20px;" v-bind:class="[{aovivo_branco:opcao.status=='LIVE'}]">
                                {{opcao.localteam_score}} : {{opcao.visitorteam_score}}
                              </div>
                              <div class="text_13 text_bold" v-bind:class="[{aovivo_vermelho:opcao.status=='LIVE'}]"> {{opcao.minute}}' </div>
                            </div>

                            <div class="col-4 text-center" style="padding:0;">
                              <div><img :src='opcao.visitorteam_logo' class="imagem"></div>
                              <div class="text_13 mt_4 text_cinza">{{opcao.visitorteam_nome.substr(0,3).toUpperCase()}}</div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12 text-center">
                              <div v-bind:class="[
                                (opcao.resultado=='S')?'verde_faixa':(opcao.resultado=='N')?'vermelho_faixa':'azulado_faixa'
                              ]">{{opcao.mercado_nome}} <br> {{traducao_opcao(opcao.opcao_nome)}}
                              </div>
                            </div>

                            <div class="col-md-12 text-center text_branco" style="padding-bottom:5px;">PONTOS:
                              <span v-if="opcao.resultado=='S' && opcao.ponto>0">+</span>
                              <span v-if="opcao.resultado=='N' && opcao.ponto>0">-</span>
                              {{opcao.ponto}}
                            </div>
                          </div>

                        </div>


                      </div>
                    </div>
                  </div>

                  <div class="col-md-6" style="padding: 0 20px 0 20px;" v-show="dados_disponiveis">

                    <div class="row pt-3 mb-2" style="background: #E4E4E408 0% 0% no-repeat padding-box; border: 1px solid #6666660D; border-radius: 5px 5px 0px 0px;">
                          <div class="col-md-12 text-center text_12 text_cinza pb-2">
                            {{resultado.liga_nome}}
                          </div>
                          <div class="col-md-12">
                              <div class="row pt-3 ps-3 pe-3">
                                <div class="col-md-4">
                                  <p class="text-center">
                                    <img :src='resultado.localteam_logo' class="imagem" :title='"sokkerduel"' width="50px"> <br>
                                    <span class="text_12 text_cinza"> {{resultado.localteam_nome}} </span>
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="text-center text_cinza text_11">
                                    <img src='../../assets/image/ponto.gif' width="10px" v-if="resultado.status == 'LIVE'" > &nbsp; {{resultado.status}}
                                  </div>
                                  <div class="text-center ">
                                    <span class="text_35 text_branco text_bold">
                                      {{resultado.localteam_score}} : {{resultado.visitorteam_score}}
                                    </span>
                                    <span class="text_15 text_bold text_vermelho">
                                      {{resultado.minute}}'
                                    </span>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <p class="text-center">
                                    <img :src='resultado.visitorteam_logo' class="imagem" :title='"sokkerduel"' width="50px"> <br>
                                    <span class="text_12 text_cinza"> {{resultado.visitorteam_nome}} </span>
                                  </p>
                                </div>
                              </div>
                          </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-md-6">
                        <button class="btn btn-sm w-100" v-bind:class="[(btn_resultados)?'btn-success':'btn-outline-success']" @click="show_resultados()">Resultados</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-sm w-100" v-bind:class="[(btn_estatisticas)?'btn-secondary':'btn-outline-secondary']" @click="show_estatisticas()">Estatísticas</button>
                      </div>
                    </div>

                    <div v-if="tela_resultados" class="row pt-3 pb-3 text_branco" style="background: #E4E4E408 0% 0% no-repeat padding-box; border: 1px solid #6666660D; border-radius: 5px 5px 0px 0px;">
                      <div v-for="resu of escanteios">
                          <div class="row" v-if="resu.team_id == resultado.time1">
                            <div class="col-md-12 text_12 mb-1" v-if="resu.tipo == 'corner'">
                              <img src='../../assets/image/bandeirinha.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.comment}}
                            </div>
                            <div class="col-md-12 text_12 mb-1" v-if="resu.tipo == 'goal'">
                              <img src='../../assets/image/bola.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.player_name}}
                            </div>
                          </div>

                          <div class="row" v-if="resu.team_id == resultado.time2">
                            <div class="col-md-12 text_12 mb-1 text-end" v-if="resu.tipo == 'corner'">
                              <img src='../../assets/image/bandeirinha.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.comment}}
                            </div>
                            <div class="col-md-12 text_12 mb-1 text-end" v-if="resu.tipo == 'goal'">
                              <img src='../../assets/image/bola.png' width="15px"> <b> {{resu.minute}}'</b>  {{resu.player_name}}
                            </div>
                          </div>
                      </div>
                    </div>

                    <div v-if="tela_estatisticas" class="row pt-3 text_branco" style="background: #E4E4E408 0% 0% no-repeat padding-box; border: 1px solid #6666660D; border-radius: 5px 5px 0px 0px;">

                      <div class="mb-3 text-center pt-5 pb-5"> Breve estatísticas </div>

                        <!--
                        <div class="mb-3">
                          <div class="text_11">
                            <div class="row">
                              <div class="col-4"> 40% </div>
                              <div class="col-6 text_bold"> Ball possession </div>
                              <div class="col-2 text-end"> 60% </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="progress-stacked">
                              <div class="progress" role="progressbar" aria-label="Segment one" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%; ">
                                <div class="progress-bar" style="background-color: #ccc;"></div>
                              </div>
                              <div class="progress" role="progressbar" aria-label="Segment two" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
                                <div class="progress-bar bg-danger"></div>
                              </div>
                              <div class="progress" role="progressbar" aria-label="Segment three" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
                                <div class="progress-bar bg-success"></div>
                              </div>
                              <div class="progress" role="progressbar" aria-label="Segment quarte" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
                                <div class="progress-bar" style="background-color: #ccc;"></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <div class="text_11">
                            <div class="row">
                              <div class="col-4"> 10% </div>
                              <div class="col-6 text_bold"> Gol attempts </div>
                              <div class="col-2 text-end"> 90% </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="progress-stacked">
                              <div class="progress" role="progressbar" aria-label="Segment one" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 0%; ">
                                <div class="progress-bar" style="background-color: #eee;"></div>
                              </div>
                              <div class="progress" role="progressbar" aria-label="Segment two" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                                <div class="progress-bar bg-danger"></div>
                              </div>
                              <div class="progress" role="progressbar" aria-label="Segment three" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                                <div class="progress-bar bg-success"></div>
                              </div>
                              <div class="progress" role="progressbar" aria-label="Segment three" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                                <div class="progress-bar" style="background-color: #eee;"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        -->

                    </div>

                  </div>
              </div>

          </div>
          <!-- FIM COLUNA 2 -->

      </div>

    </div>
    </div>
    </div>

    <ccDetalheTorneio ref="cc_detalhe_torneio"></ccDetalheTorneio>

    <ccFooter></ccFooter>
</div>
</template>

<script>
import axios from 'axios'
import io from 'socket.io-client'
import ccMenu from '../layout/menu.vue'
import ccFooter from '../layout/footer.vue'
import ccJogoResultado from '../cc_geral/cc_jogo_resultado.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccDetalheTorneio from '../cc_geral/cc_detalhe_torneio_modal.vue'

export default {
  data () {
    return {

      //socket
      canal1 : null,
      canal2 : null,
      countSocket: 0,
      fala_servidor: null,
      fonte: null,

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      errors: [],

      //variaveis
      ultimo_que_ganha: 0,
      banca: 0,
      torneio_id_sec: 0,
      qtd_aposta: 0,
      meus_total_ganhos: 0,
      sua_colocacao: 0,
      qtd_slide: 0,
      dados_disponiveis: false,
      timer_minutos_apostas: null,
      logado: 0,
      qtd_minhas_apostas: 0,

      //objeto
      torneio: {},
      resultado: {},

      //arrays
      prize: [],
      apostas: [],
      apostas_page: [],
      jogos: [],
      mercados: [],
      mercado_opcao: [],
      escanteios: [],

      //escolhidos
      aposta_id: 0,
      fixture_id: 0,
      aposta_escolhida_nickname: null,
      aposta_escolhida_rank: null,
      aposta_escolhida_valor_ganho: null,

      //hash
      hash_aposta: null,
      hash_mercado: null,

      //paginação
      qtd_registro: 30,
      filter_username: "",
      page: 1,
      page_ultimo: 0,
      only: 0,

      tela_ranking: true,
      tela_detalhes: false,
      tela_jogos: false,
      tela_bet: false,
      tela_resultados: true,
      tela_estatisticas: false,

      btn_resultados: true,
      btn_estatisticas: false,

      //temp
      dados_temp_apostas: null,
      dados_temp_jogos: null,
      dados_temp_box: false,

      //count
      count_minhas_apostas: 0,

      meus_palpites: [],
      liga: [],
    }
  },

  components: {ccMenu, ccFooter, ccJogoResultado, ccLoading, ccDetalheTorneio, ccFooter},

  created(){
    document.title = 'Meu Torneio - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  mounted(){
    this.torneio_id_sec = this.$route.params.torneio_id;

    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
      this.logado = 0
    }else{
      this.user = a
      this.logado = 1
    }

    this.escute_canal()

    this.get_torneio()
  },

  methods: {
    escute_canal(){
      this.socket = this.$store.state.socket;
      this.canal1 = "canal_torneio_"+this.torneio_id_sec+"_aposta"

      this.socket.on( this.canal1, (data) => {
        this.fonte = data.fonte
        this.dados_temp_apostas = data.resp
        this.get_aposta_vindo_do_websocket()
        this.dados_temp_box = true
      });
    },

    //TORNEIO --------------------------------------------
    get_torneio(){
      this.loading = true
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'torneio/find_id/'+this.torneio_id_sec, header)
      .then(response => {

        this.loading = false
        this.torneio = response.data.resp.torneio
        this.torneio.dt_inicio = this.timestamp_dataBR(this.torneio.dt_inicio_timestamp)
        this.torneio.dt_termino = this.previsao_termino(this.torneio.dt_terminio_timestamp)
        this.prize = response.data.resp.prize
        this.qtd_aposta = response.data.resp.torneio.qtd_aposta
        this.porc_casa = response.data.resp.torneio.porc_casa
        this.jogos = response.data.resp.jogo
        this.dt_inicio_timestamp = response.data.resp.dt_inicio_timestamp

        document.title = this.torneio.nome+': R$'+this.torneio.prize+' - SokkerDuel';

        //status nome, descricao
        this.torneio.status_nome = this.torneio_status_nome(this.torneio.status)

        //tipo do torneio
        this.torneio.tipo_nome = this.torneio_tipo_nome(this.torneio.tipo_id)

        //higienize - ultimo que ganha
        this.ultimo_que_ganha = this.prize[ response.data.resp.prize.length-1 ].p2;

        //calcule o valor da banca
        this.get_banca()

        //inicialize apostas
        this.get_aposta()

        //ligue o timer
        if(this.torneio.status == 3){
          this.start_time()
        }else{
          clearInterval(this.timer_minutos_apostas);
        }

        this.atualize_minutos_dos_jogos()

      })
      .catch(e => {
        this.errors.push(e);
        this.loading = false
      });
    },

    get_banca(){
      let casa = 0
      let total_dinheiro = 0

      if(this.torneio.tipo_id == 1 || this.torneio.tipo_id == 2){
        total_dinheiro = this.qtd_aposta * this.torneio.taxa_entrada
      }else{
        total_dinheiro = this.torneio.prize
      }

      //h2h
      if(this.torneio.tipo_id == 1){
        casa =  (total_dinheiro * this.torneio.porc_casa)/100;
        this.banca = total_dinheiro - casa;
      }

      //fixed
      if(this.torneio.tipo_id == 2){
        casa = (this.qtd_aposta - this.torneio.min_pessoa) * this.torneio.taxa_entrada
        this.banca = total_dinheiro - casa
      }

      //free
      if(this.torneio.tipo_id == 3){
        casa = 0
        this.banca = this.torneio.prize
      }
    },

    // APOSTAS -------------------------------------------------------------
    get_aposta(){
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'torneio/'+this.torneio.id+'/aposta', header)
      .then(response => {

        this.loading = false;
        let a = response.data.resp
        var obj = {};
        var aposta = [];
        var p = this.prize;
        var porc = 0;
        var ranger = 0;

        for (var i=0; i <= a.length -1; i++) {
          porc = 0;
          for (var c=0; c <= p.length -1; c++) {
            if(a[i].rank >= p[c].p1 && a[i].rank <= p[c].p2 ){
              porc = p[c].porcentagem;
              ranger = p[c].ranger;
            }
          }

          obj = {
            aposta_id: a[i].aposta_id,
            aposta_id_sec: a[i].aposta_id_sec.substr(0,8),
            rank: a[i].rank,
            repetido: a[i].repetido,
            user_id: a[i].user_id,
            username: a[i].username,
            ponto: a[i].ponto,
            entrada: a[i].entrada,
            //prize_old:  (((this.banca * porc) / 100)/ranger)/a[i].repetido,
            prize: parseFloat(a[i].prize),
            cadeado: 0,
            escolha: 0,
          };

          aposta.push(obj);
        }

        this.apostas = aposta;

        //se aposta_id > 0 entao permaneca senao pegue a primeira aposta
        if(this.aposta_id == 0){

            if(this.torneio.status > 1){
                this.aposta_id = this.apostas[0].aposta_id
                this.apostas[0].escolha = 1
                this.aposta_escolhida_rank = this.apostas[0].rank
                this.aposta_escolhida_nickname = this.apostas[0].username
                this.aposta_escolhida_valor_ganho = Math.round((this.apostas[0].prize) * 100)/100
                this.get_mercado()
            }else{
                var lista = this.apostas.map(function(e) { return e.username; })
                var fou = lista.indexOf(this.user.username)
                this.apostas[fou].escolha = 1
                this.aposta_escolhida_rank = this.apostas[fou].rank
                this.aposta_escolhida_nickname = this.apostas[fou].username
                this.aposta_escolhida_valor_ganho = Math.round((this.apostas[fou].prize) * 100)/100
                this.selecione_aposta(this.apostas[fou].aposta_id)
            }

        }else{
            var poste = this.apostas.map(function(e) { return e.aposta_id; })
            let found = poste.indexOf(this.aposta_id)
            this.apostas[found].escolha = 1
        }

        //alimentar componente aposta
        this.paginacao_so_minhas_apostas();
        this.paginacao_apostas();

        this.atualize_minutos_dos_jogos()

        this.hash_aposta = response.data.hash_aposta;
      })
      .catch(e => {
      });
    },

    get_aposta_vindo_do_websocket()
    {
        //torneio ----------------
        let t = this.dados_temp_apostas.torneio.torneio;
        this.torneio.status = t.status
        this.torneio.status_nome = this.torneio_status_nome(t.status)

        //ligue o time se o status pular para acontecendo
        if(t.status == 3){
          this.start_time()
        }else{
          clearInterval(this.timer_minutos_apostas);
        }

        //jogos ----------------
        this.jogos = this.dados_temp_apostas.torneio.jogo;
        this.get_resultado(this.fixture_id)

        //Aposta ---------------
        this.loading = false;
        let a = this.dados_temp_apostas.aposta;
        var obj = {};
        var aposta = [];
        var p = this.prize;
        var porc = 0;
        var ranger = 0;

        let colocacao = "";
        for (var i=0; i <= a.length -1; i++) {
          porc = 0;
          for (var c=0; c <= p.length -1; c++) {
            if(a[i].rank >= p[c].p1 && a[i].rank <= p[c].p2 ){
              porc = p[c].porcentagem;
              ranger = p[c].ranger;
            }
          }

          obj = {
            aposta_id: a[i].aposta_id,
            aposta_id_sec: a[i].aposta_id_sec.substr(0,8),
            rank: a[i].rank,
            repetido: a[i].repetido,
            user_id: a[i].user_id,
            username: a[i].username,
            ponto: a[i].ponto,
            entrada: a[i].entrada,
            prize: parseFloat(a[i].prize),
            cadeado: 0,
            escolha: 0,
          };
          aposta.push(obj);
        }
        this.apostas = aposta;

        //se aposta_id > 0 entao permaneca senao pegue a primeira aposta
        if(this.aposta_id == 0){
            if(this.torneio.status > 1){
                this.aposta_id = this.apostas[0].aposta_id
                this.apostas[0].escolha = 1
                this.aposta_escolhida_rank = this.apostas[0].rank
                this.aposta_escolhida_nickname = this.apostas[0].username
                this.aposta_escolhida_valor_ganho = Math.round((this.apostas[0].prize) * 100)/100
                this.get_mercado()
            }else{
                var lista = this.apostas.map(function(e) { return e.username; })
                var fou = lista.indexOf(this.user.username)
                this.apostas[fou].escolha = 1
                this.aposta_escolhida_rank = this.apostas[fou].rank
                this.aposta_escolhida_nickname = this.apostas[fou].username
                this.aposta_escolhida_valor_ganho = Math.round((this.apostas[fou].prize) * 100)/100
                this.selecione_aposta(this.apostas[fou].aposta_id)
            }
        }else{
            var poste = this.apostas.map(function(e) { return e.aposta_id; })
            let found = poste.indexOf(this.aposta_id)
            this.apostas[found].escolha = 1
        }

        this.paginacao_so_minhas_apostas();
        this.paginacao_apostas();

        this.atualize_minutos_dos_jogos()

        this.get_mercado()
    },

    paginacao_so_minhas_apostas(){
      let a = this.apostas;
      var obj = {};
      var p = this.prize;
      var t = [];
      var porc = 0;
      var ranger = 0;

      for (var i=0; i <= a.length -1; i++) {
        porc = 0;
        ranger = 0;
        for (var c=0; c <= p.length -1; c++) {
          if(a[i].rank >= p[c].p1 && a[i].rank <= p[c].p2 ){
            porc = p[c].porcentagem;
            ranger = p[c].ranger;
          }
        }

        //faca a pesquisa para somente eu
        if( a[i].user_id == this.user.id ){
            obj = {
              aposta_id: a[i].aposta_id,
              aposta_id_sec: a[i].aposta_id_sec,
              rank: a[i].rank,
              repetido: a[i].repetido,
              user_id: a[i].user_id,
              username: a[i].username,
              ponto: a[i].ponto,
              entrada: a[i].entrada,
              prize: a[i].prize,
              escolha: a[i].escolha,
            };

            if(this.torneio.status < 2 && this.torneio.tipo_id != 4){
              if(obj.user_id == this.user.id){
                obj.cadeado = 1;
              }else{
                obj.cadeado = 0;
              }
            }else{
              obj.cadeado = 1;
            }

            t.push(obj);
        }
      }

      this.meus_palpites = t
    },

    //paginacao de apostas (tabela)
    paginacao_apostas(){
      if(this.only == 1){
        this.filter_username = ""
      }

      let pesq = this.filter_username.toLowerCase();
      let a = this.apostas;
      var obj = {};
      var aposta_page_aux = [];
      var aposta_page = [];
      var p = this.prize;
      var porc = 0;
      var ranger = 0;
      var colocacao = 0;

      this.meus_total_ganhos = 0;

      for (var i=0; i <= a.length -1; i++) {

        porc = 0;
        for (var c=0; c <= p.length -1; c++) {
          if(a[i].rank >= p[c].p1 && a[i].rank <= p[c].p2 ){
            porc = p[c].porcentagem;
            ranger = p[c].ranger;
          }
        }

        if( this.only == 0 ){
          //faca a pesquisa para nome
          if( pesq == null || pesq == "" || a[i].username.toLowerCase().indexOf(pesq) >= 0 ){
            obj = {
              aposta_id: a[i].aposta_id,
              aposta_id_sec: a[i].aposta_id_sec,
              rank: a[i].rank,
              repetido: a[i].repetido,
              user_id: a[i].user_id,
              username: a[i].username,
              ponto: a[i].ponto,
              entrada: a[i].entrada,
              prize: a[i].prize,
              escolha: a[i].escolha,
            };
            aposta_page_aux.push(obj);
          }
        }else{
          //faca a pesquisa para somente eu
          if( a[i].user_id == this.user.id ){
              obj = {
                aposta_id: a[i].aposta_id,
                aposta_id_sec: a[i].aposta_id_sec,
                rank: a[i].rank,
                repetido: a[i].repetido,
                user_id: a[i].user_id,
                username: a[i].username,
                ponto: a[i].ponto,
                entrada: a[i].entrada,
                prize: a[i].prize,
                escolha: a[i].escolha,
              };
              aposta_page_aux.push(obj);
          }
        }

        //pegue o meu total de ganhos
        var temp = 0;
        if( a[i].user_id == this.user.id ){
          this.qtd_minhas_apostas = this.qtd_minhas_apostas + 1
          this.meus_total_ganhos = Math.round((this.meus_total_ganhos + a[i].prize) * 100)/100
        }

        //pegue as colocações do usuario
        if(a[i].user_id == this.user.id){
          colocacao = colocacao + a[i].rank + "º, ";
        }
        this.sua_colocacao = colocacao;
      }

      //calculo de paginacao
      let total = aposta_page_aux.length;
      let qtd_registro = this.qtd_registro;
      var quociente = Math.floor(total/qtd_registro);
      var resto = total%qtd_registro;

      if(resto > 0){
        this.page_ultimo = quociente + 1;
      }else{
        this.page_ultimo = quociente;
      }

      let fim = qtd_registro * this.page;
      let inicio = fim - qtd_registro;

      for (var i=0; i <= aposta_page_aux.length -1; i++){
        obj = {
          aposta_id: aposta_page_aux[i].aposta_id,
          aposta_id_sec: aposta_page_aux[i].aposta_id_sec,
          rank: aposta_page_aux[i].rank,
          repetido: aposta_page_aux[i].repetido,
          user_id: aposta_page_aux[i].user_id,
          username: aposta_page_aux[i].username,
          ponto: aposta_page_aux[i].ponto,
          entrada: aposta_page_aux[i].entrada,
          prize: aposta_page_aux[i].prize,
          escolha: aposta_page_aux[i].escolha,
        };

        if(this.torneio.status < 2){
          if(obj.user_id == this.user.id){
            obj.cadeado = 1;
          }else{
            obj.cadeado = 0;
          }
        }else{
          obj.cadeado = 1;
        }

        if(i>=inicio && i<fim){
          aposta_page.push(obj);
        }

      }
      this.apostas_page = aposta_page;
    },

    filter_nome_usuario(){
      this.paginacao_apostas();
      this.page = 1;
    },

    page_menos(){
      if(this.page > 1){
        this.page = this.page - 1;
      }else{
        this.page = 1;
      }
      this.paginacao_apostas();
    },

    page_add(){
      if(this.page < this.page_ultimo){
        this.page = this.page + 1;
      }else{
        this.page = this.page_ultimo;
      }
      this.paginacao_apostas();
    },

    page_primeiro(){
      this.page = 1;
      this.paginacao_apostas();
    },

    page_ultima(){
      this.page = this.page_ultimo;
      this.paginacao_apostas();
    },

    show_only(){
      let aux = 0
      if(this.only == 0){
        this.only = 1;
      }else{
        this.only = 0;
      }

      this.paginacao_apostas();
    },

    selecione_aposta(aposta_id){
      this.aposta_id = aposta_id

      for (var i=0; i <= this.apostas_page.length -1; i++)
      {
        this.apostas_page[i].escolha = 0
        if(this.apostas_page[i].aposta_id == aposta_id){
          this.apostas_page[i].escolha = 1
          this.aposta_escolhida_rank = this.apostas_page[i].rank
          this.aposta_escolhida_nickname = this.apostas_page[i].username
          this.aposta_escolhida_valor_ganho = Math.round((this.apostas_page[i].prize) * 100)/100
        }
      }

      this.get_mercado()

      this.tela_bet_show()

      //atualize os minutos
      this.atualize_minutos_dos_jogos()
    },

    // JOGOS/MERCADOS/OPCOES --------------------------------------------------
    /*
    get_mercado(){

      this.loading = true
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'torneio/'+this.torneio.id+'/aposta/'+this.aposta_id+'/mercado/opcao', header)
      .then(response => {

          let mj = response.data.resp.mercado_jogo;

          //higienizar - separe os jogos
          let aux = 0;
          let obj = {};
          this.mercado_opcao = [];

          var mercado_nome = null

          if(mj != null){
            if(mj.length > 0){

              for (var i=0; i <= mj.length -1; i++)
              {
                  switch(mj[i].mercado_id_fk) {
                    case 1: mercado_nome = "1X2 Market FT"; break;
                    case 2: mercado_nome = "1X2 Market HT"; break;
                    case 3: mercado_nome = "Goals Market FT"; break;
                    case 4: mercado_nome = "Goals Market HT"; break;
                    case 5: mercado_nome = "Btts Market FT"; break;
                    case 6: mercado_nome = "Btts Market HT"; break;
                    case 7: mercado_nome = "Conner Market FT"; break;
                    case 8: mercado_nome = "Conner Market HT"; break;
                  }

                  obj = {
                    fixture_id: mj[i].fixture_id_fk,
                    status: mj[i].status,
                    minute: mj[i].minute,
                    time1: mj[i].time1,
                    time2: mj[i].time2,
                    localteam_nome: mj[i].localteam_nome,
                    visitorteam_nome: mj[i].visitorteam_nome,
                    localteam_score: mj[i].localteam_score,
                    visitorteam_score: mj[i].visitorteam_score,
                    localteam_logo: mj[i].localteam_logo,
                    visitorteam_logo: mj[i].visitorteam_logo,
                    goals: mj[i].goals,
                    corners: mj[i].corners,
                    dt_inicio: mj[i].dt_inicio,
                    check: 0,
                    marcado: 0,
                    mercado_id_fk: mj[i].mercado_id_fk,
                    mercado_nome: mercado_nome,
                    opcao_nome: mj[i].nome,
                    mercado_tipo: mj[i].tipo,
                    ponto: mj[i].ponto,
                    resultado: mj[i].resultado,
                  }

                  this.mercado_opcao.push(obj);
              }

              //pegue o primeiro jogo da aposta e chame o resultado
              this.fixture_id = this.mercado_opcao[0].fixture_id

              this.get_resultado(this.fixture_id)

              this.dados_disponiveis = true

            }else{
              this.dados_disponiveis = false
            }
          }

          this.loading = false

      })
      .catch(e => {

        console.log(e.message)

        // let self = this
        // if(e.response.status==401){
        //   if(e.response.statusText=="Unauthorized"){
        //     alert("Sessão expirou")
        //     self.$router.push({path: '/'});
        //   }
        // }
      });
    },
    */

    get_mercado() {
      this.loading = true;
      const header = { headers: { 'x-access-token': this.user.access_token } };

      axios.get(`${this.base_url_api}torneio/${this.torneio.id}/aposta/${this.aposta_id}/mercado/opcao`, header)
        .then(response => {
          const mj = response.data.resp.mercado_jogo;

          if (mj && mj.length > 0) {
            const mercadoNomes = {
              1: "Vencedor",
              2: "Vencedor - 1º tempo",
              3: "Gols",
              4: "Gols 1º Tempo",
              5: "Ambos marcam?",
              6: "Ambos marcam- 1º tempo?",
              7: "Escanteios",
              8: "Escanteios 1º Tempo",
              9: "CANTO DO MINUTO 0:00 ATÉ 9:59?",
              10: "CANTO DO MINUTO 10:00 ATÉ 19:59?",
              11: "CANTO DO MINUTO 20:00 ATÉ 29:59?",
              12: "CANTO DO MINUTO 30:00 ATÉ 39:59?",
              13: "CANTO DO MINUTO 50:00 ATÉ 59:59?",
              14: "CANTO DO MINUTO 60:00 ATÉ 69:59?",
              15: "CANTO DO MINUTO 70:00 ATÉ 79:59?",
              16: "CANTO DO MINUTO 80:00 ATÉ 88:59?",
              17: "GOL DO MINUTO 00:00 ATÉ 25:59?",
              18: "GOL DO MINUTO 26:00 ATÉ 44:59?",
              19: "GOL DO MINUTO 50:00 ATÉ 75:59?",
              20: "GOL DO MINUTO 76:00 ATÉ 88:59?",
            };

            this.mercado_opcao = mj.map(item => {
              const mercado_nome = mercadoNomes[item.mercado_id_fk] || null;

              return {
                fixture_id: item.fixture_id_fk,
                status: item.status,
                minute: item.minute,
                time1: item.time1,
                time2: item.time2,
                localteam_nome: item.localteam_nome,
                visitorteam_nome: item.visitorteam_nome,
                localteam_score: item.localteam_score,
                visitorteam_score: item.visitorteam_score,
                localteam_logo: item.localteam_logo,
                visitorteam_logo: item.visitorteam_logo,
                goals: item.goals,
                corners: item.corners,
                dt_inicio: item.dt_inicio,
                check: 0,
                marcado: 0,
                mercado_id_fk: item.mercado_id_fk,
                mercado_nome: mercado_nome,
                opcao_nome: item.nome,
                mercado_tipo: item.tipo,
                ponto: item.ponto,
                resultado: item.resultado,
              };
            });


            this.fixture_id = this.mercado_opcao[0].fixture_id;
            this.get_resultado(this.fixture_id);
            this.dados_disponiveis = true;
          } else {
            this.dados_disponiveis = false;
          }

          this.loading = false;
        })
        .catch(error => {
          console.log(error.message);
          // Tratamento de erros

          this.loading = false
        });
    },


    //Habilitar telas ------------------------------------------------------------

    tela_ranking_show(){
      this.tela_ranking = true
      this.tela_detalhes = false
      this.tela_jogos = false
      this.tela_bet = false
    },

    tela_detalhes_show(){
      this.tela_detalhes = true
      this.tela_ranking = false
      this.tela_jogos = false
      this.tela_bet = false
    },

    tela_jogos_show(){
      this.tela_jogos = true
      this.tela_detalhes = false
      this.tela_ranking = false
      this.tela_bet = false
    },

    tela_bet_show(){
      this.tela_bet = true
      this.tela_jogos = false
      this.tela_detalhes = false
      this.tela_ranking = false
    },

    //---- RESULTADO ---------------------------
    get_resultado(fixture_id)
    {
      this.fixture_id = fixture_id
      var j = this.jogos;
      var obj = j.find(item => item.fixture_id === this.fixture_id);

      this.resultado = obj ? {
        fixture_id: obj.fixture_id,
        liga_nome: obj.liga_nome,
        localteam_nome: obj.time1_nome,
        localteam_score: obj.localteam_score,
        localteam_logo: obj.localteam_logo,
        visitorteam_nome: obj.time2_nome,
        visitorteam_score: obj.visitorteam_score,
        visitorteam_logo: obj.visitorteam_logo,
        minute: obj.minute,
        status: obj.status,
        goals: obj.goals,
        corners: obj.corners,
        time1: obj.time1,
        time2: obj.time2,
      } : {};

      //escanteios
      var corners = [];
      if(obj.corners != null){
        if(obj.corners.length != 0){
        corners = JSON.parse(obj.corners);
        }
      }else{
        corners = [];
      }

      //gols
      var goals = [];
      if(obj.goals != null){
        if(obj.goals.length != 0){
        goals = JSON.parse(obj.goals);
        }
      }else{
        goals = 0;
      }


      var obj1 = {};

      //coloque os conners retirando o 'Race to'
      var result = corners.filter(function(corner) {
        return !corner.comment.startsWith('Race to');
      }).map(function(corner) {
        return {
          tipo: 'corner',
          id: corner.id,
          team_id: corner.team_id,
          fixture_id: corner.fixture_id,
          minute: corner.minute,
          comment: corner.comment
        };
      });

      for (var n = 0; n < goals.length; n++) {
        obj1 = {
          tipo: 'goal',
          id: goals[n].id,
          team_id: goals[n].team_id,
          fixture_id: goals[n].fixture_id,
          minute: goals[n].minute,
          player_id: goals[n].player_id,
          player_name: goals[n].player_name,
          result: goals[n].result,
        }
        result.push(obj1);
      }

      //ordernar corners com goals
      result.sort(function(a,b) {
        return a.minute < b.minute ? -1 : a.minute > b.minute ? 1 : 0;
      });

      this.escanteios = result;

      // this.$refs.cc_jogo_resultado.receber_dados(this.resultado, this.escanteios);
    },
    //---- FIM RESULTADO --------------------------


    /*timer -------------------------------*/
    atualize_minutos_dos_jogos(){
      let array_aux = []
      for (var i=0; i <= this.jogos.length -1; i++) {
        array_aux.push(this.jogos[i].fixture_id);
      }

      var body = { fixtures: array_aux };
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.post(this.base_url_api+'get_all_fixture_redis',body, header)
      .then(response => {

        for (var n=0; n <= response.data.length -1; n++) {
          this.mercado_opcao.forEach(objeto => {
            if (objeto.fixture_id === response.data[n].fixture_id) {
              objeto.minute = response.data[n].min;
            }
          });

          this.jogos.forEach(objeto => {
            if (objeto.fixture_id === response.data[n].fixture_id) {
              objeto.minute = response.data[n].min;
            }
          });
        }

        let obj = response.data.find(item => item.fixture_id == this.fixture_id)
        this.resultado.minute = obj.min


        // let obj1 = this.jogos.find(item => item.fixture_id == this.fixture_id)
        // console.log(obj1.fixture_id+'-'+obj1.minute)


      })
      .catch(e => {
        this.errors.push(e);
      });
    },

    // TIMERS -----------------------------------------------------
    start_time(){
      this.timer_minutos_apostas = setInterval( function() {
        this.atualize_minutos_dos_jogos()
      }.bind(this), 40000);
    },

    stop_time(){
      clearInterval(this.timer_minutos_apostas)
    },

    show_resultados(){
      this.tela_resultados = true
      this.tela_estatisticas = false
      this.btn_resultados = true
      this.btn_estatisticas = false
    },

    show_estatisticas(){
      this.tela_resultados = false
      this.tela_estatisticas = true
      this.btn_resultados = false
      this.btn_estatisticas = true
    },

  },

  destroyed()
  {
    clearInterval(this.timer_minutos_apostas)
    this.stop_time()
  }


}
</script>


<style scoped>

  input.form-control{
    background: #36394580 0% 0% no-repeat padding-box;
    border: 2px solid #3E3E3E80;
    border-radius: 5px;
    margin-bottom:10px;
    background-image: url("../../assets/image/lupa.svg");
    background-size: 20px;
    background-position: right;
    background-repeat: no-repeat;
    color: #ffffff80;
  }

  input.form-control::placeholder {
    color: #ffffff80;
    font-size: 13px;
  }

  /* GERAL : FIM -----------  */

  /* CARACTERISTICAS DO TORNEIO E SUAS APOSTAS ----------------*/

  .box1{
    background: #171A28 0% 0% no-repeat padding-box;
    border-radius: 17px 17px 0px 0px;
    color:  #fff;
    font-size: 13px;
  }

  .box1 .coluna_tonament_name{
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 12px 12px 0px 0px;
    padding: 10px;
    margin-top: 10px;
    font-size: 13px;
  }

  .box1 .divisao_tracejada{
    border: 1px dashed #707070;
    margin: 10px 0 10px 0;
  }

  .caixa_aposta{
    height: 430px;
    overflow:auto;
  }

  .tabela{
    color:  #ffffff80;
    font-size: 10px;
  }

  .tabela thead th {
    color: #ffffff;
    border-bottom: 0px;
    border: 0;
    font-size: 10px;
  }

  .tabela th, .tabela td {
    border-bottom: 0px;
    cursor: pointer;
    padding: 0.2rem;
    border: 0;
  }

  .tabela tr:hover{
    color: greenyellow;
    background-color: rgba(255, 255, 255, 0.14);
  }

  .tabela .escolheu_aposta{
    background-color: rgba(92, 183, 13, 0.3);
  }

  .tabela .disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }

  .page-link{
    border: 0;
    background-color: transparent;
    color:  greenyellow;
    font-family: myFontBold;
  }

  .paginas{
    padding-top: 5px;
    color: #444;
  }

  .only_true{
    color: greenyellow;
  }

  .only_false{
    color: #ffffff80;
  }



  /* CARACTERISTICAS DO TORNEIO E SUAS APOSTAS : FIM ----------------*/

  #box_mercado_opcoes{
    height: 750px;
  }

  #box_mercado_opcoes .apagado{
    opacity: 1;
  }

  #box_mercado_opcoes .acesso{
    opacity: 1;
  }

  #box_mercado_opcoes .opcao{
    background-color: #101324;
    font-size: 11px !important;
  }

  #box_mercado_opcoes .opcao .imagem{
    width: 33px;
    height: 33px;
  }

  #box_mercado_opcoes .opcao .placar{
    padding-top: 13px;
    font-size: 24px;
    font-weight: bolder;
  }

  #box_mercado_opcoes .opcao.pontos {
  text-align: center;
  }

  #box_mercado_opcoes .opcao .aovivo_vermelho{
    color: red;
  }

  #box_mercado_opcoes .opcao .aovivo_branco{
    color: #ffffff;
  }



  /* AZULADO - aguardando*/
  #box_mercado_opcoes .opcao.azulado{
    background: #99AEE41A;
    color: #99AEE480;
  }
  #box_mercado_opcoes .azulado_faixa{
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 4px 0 4px 0;
    background-color: #99AEE426;
    color: #99AEE480;
  }
  /*AZULADO - FIM */


  /* VERDE - positivo */
  #box_mercado_opcoes .opcao.verde{
    background: #5CB70D33;
    color: #5CB70D;
  }

  #box_mercado_opcoes .verde_faixa{
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 4px 0 4px 0;
    background-color: rgba(92, 183, 13, 0.2);
    color: #5CB70D;
  }
  /* VERDE - FIM */


  #box_mercado_opcoes .opcao.vermelho{
  background-color: rgba(255, 51, 0, 0.2);
  color: #FF3300;
  }
  #box_mercado_opcoes .vermelho_faixa{
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 4px 0 4px 0;
    background-color: #FF33001A;
  }



  /* CINZA */
  #box_mercado_opcoes .opcao.cinza{
    background-color: #FFFFFF0D;
    color: FFFFFF4D;
  }
  #box_mercado_opcoes .cinza-faixa{
    background-color: #FFFFFF1A;
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 4px 0 4px 0;
  }
  /* CINZA - FIM */


  /* AMARELO */
  #box_mercado_opcoes .opcao.amarelo{
    background-color: rgb(150, 150, 9);
    color: FFFFFF4D;
  }
  #box_mercado_opcoes .amarelo-faixa{
    background-color: rgb(120, 137, 92);
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 4px 0 4px 0;
  }
  /* CINZA - FIM */



  /* RSULTADOS ----------------------------- */

  .btn_detalhes{
    width: 115px;
    height: 28px;
    border-radius: 10px;
    font-size: 12px;
    background-color: rgba(153, 173, 228, 0.3);
    text-align: center;
    padding-top: 5px;
    float: right;
  }

  .btn_estatisticas{
    width: 115px;
    height: 28px;
    border-radius: 10px;
    font-size: 12px;
    background-color: transparent;
    text-align: center;
    padding-top: 5px;
    float: left;
    border: solid 1px rgba(153, 173, 228, 0.3);
  }


</style>


// WEBPACK FOOTER //
// src/components/meu/minha_aposta.vue